import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ContextState from "./context_state_config";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import { Provider } from "react-redux";
import { store } from "./store/redux/createReduxStore";
import VersionDialog from "components/versionDialog";
import "./Api.css";
const App = () => {
  const theme = createTheme(); // This uses the default theme as a base
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router>
          <ContextState />
          <VersionDialog />
        </Router>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
